import { Component, HostListener, Input, OnDestroy, QueryList, ViewChildren } from '@angular/core';


import { PermissionsService } from '../../../shared/permissions.service';
import { Permissions } from '../../../shared/permissions.enum';

import { MatDrawer } from '@angular/material/sidenav';
import { SlideNavService } from '../slidenav.service';

@Component({
    selector: 'slidenavbar',
    templateUrl: 'slidenavbar.component.html'
})
export class SlideNavBarComponent implements OnDestroy {
    @Input('slideDrawer') public slideDrawer: MatDrawer;

    searchText = '';
    searchSlides = this.slidenav.utils.rand();
    slideElHeight = 52;

    @ViewChildren('slidenavbar') slides: QueryList<any>;
    @HostListener('window:resize')
    resize() {
        this.setSlideHeight();
    }

    get Permissions() {
        return Permissions;
    }

    constructor(
        public slidenav: SlideNavService,
        public permissionsService: PermissionsService
    ) {
        this.setSlideHeight();
    }

    drop(e) {
        this.slidenav.drop(this.slides, e);
    }

    setSlideHeight() {
        if( window.innerWidth < 1030 ) {
            this.slideElHeight = 33;
        } else {
            this.slideElHeight = 52;
        }
    }
    
    getPropValues(props) {
        return (obj) => {
            return props.map(prop => obj[prop]).join('');
        }
    }
    
    getSearchString(item) {
        let searchString = '';
        searchString += JSON.stringify(item.headers);
        searchString += this.getPropValues([
            'metaDescription', 
            'metaTitle', 
            'title', 
            'teaser'
        ])(item);

        // add content
        let contentFields = [ item.content, item.summary ];
        contentFields.forEach((content) => {
            for(var i = 0; i < content.length; i++) {
                let result = content[i];
                searchString += this.getPropValues(['text', 'title'])(result);
                if( result.hasOwnProperty('image') ) {
                    let image = result.image;
                    searchString += this.getPropValues([
                        'alt', 
                        'caption', 
                        'credit', 
                        'description',
                        'filename',
                        'mime',
                        'name',
                        'title',
                        'url'
                    ])(image);
                }
            }
        });

        // add images
        searchString += item.images.map(this.getPropValues([
            'alt', 
            'caption', 
            'credit', 
            'description',
            'filename',
            'mime',
            'name',
            'title',
            'url'
        ])).join('');

        // add search
        searchString += item.search.map(this.getPropValues([
            'name'
        ])).join('');

        // add comments
        let comments = item.hasOwnProperty('comments') ? item.comments : [];
        searchString += comments.map(this.getPropValues([
            'abbreviation', 
            'author_name', 
            'text'
        ])).join('');

        // add quiz feedback
        searchString += item.feedback.map(this.getPropValues([
            'text'
        ])).join('');

        return searchString;
    }
    searchFilter(items, searchText) {
        let value = searchText.toLowerCase();
        if( !value || value === '' ) {
            return items;
        }
        return items.filter(item => {
            const searchString = this.getSearchString(item);
            return searchString.toLowerCase().indexOf(value) !== -1
        });
    }

    ngOnDestroy(): void {
        this.slidenav.ngOnDestroy();
    }
}